export default __webpack_public_path__ + "static/media/knowello.833b65ac.png";